import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useDateFormatter } from '../../util/hooks';

interface DateFieldProps {
  date?: string | null;
  fallback?: string;
}

const DateField = (props: DateFieldProps): ReactElement => {
  const { date } = props;
  const { i18n } = useTranslation();

  const formattedDate = useDateFormatter(date);

  const fallback = props.fallback ?? i18n.t('common:unknown');

  return <>{formattedDate ?? fallback}</>;
};

export { DateField };
